import { observer } from "mobx-react";
import React from "react";
import styled from "styled-components";

import questionImage from "./images/question.svg";
import warningImage from "./images/warning.svg";

type WrapperProps = {
  marginLeft?: number;
  marginBottom?: number;
  warning?: boolean;
};
const Wrapper = styled.div<WrapperProps>`
  width: 16px;
  height: 16px;
  background: url("${props => (props.warning ? warningImage : questionImage)}")
    center no-repeat;
  display: inline-block;
  margin-left: ${(props: any) =>
    props.marginLeft != null ? `${props.marginLeft}px` : "4px"};
  margin-bottom: ${(props: any) =>
    props.marginBottom != null ? `${props.marginBottom}px` : "-4px"};
`;
type Props = {
  text: string;
  marginLeft?: number;
  marginBottom?: number;
  className?: string;
  warning?: boolean;
};
@observer
class InfoIcon extends React.Component<Props> {
  render() {
    return (
      <Wrapper
        data-tip={this.props.text}
        marginLeft={this.props.marginLeft}
        marginBottom={this.props.marginBottom}
        className={this.props.className}
        warning={this.props.warning}
      />
    );
  }
}

export default InfoIcon;
